<template>
  <div class="confirmation">
    <div class="confirmation__container">
      <button class="btn btn__close" @click="$emit('cancel')"></button>
      <h1 class="confirmation__title" v-text="data.title"></h1>
      <p class="confirmation__text" v-text="data.text"></p>
      <div class="confirmation__options">
        <button class="btn btn__action btn--regular" @click="$parent.$emit('continue')">Continuar</button>
        <button class="btn btn__caution btn--regular" @click="$emit('cancel')">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: function () {
        return {
          title: '¿Desea realizar esta acción?',
          text: 'Si acepta continuar, la acción realizada no se podrá revertir, al cancelar no se tomará acción alguna.',
          action: 'continue'
        }
      }
    }
  },
  mounted: function () {
    document.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.$emit('cancel')
      }
    })
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/layout/_confirmation"
</style>



// WEBPACK FOOTER //
// src/components/layout/confirmation.vue